import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { useStateContext } from './contexts/ContextProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TapuRayicBedel from './OuterCorparationWeb/Revenue/TapuRayicBedel';
import CustomLogin from './OuterCorparationWeb/Account/CustomLogin';
import { BlsButton } from "./components/ui-common";
import ParameterConstants from './constants/ParameterConstants';
import PasswordChange from './pages/PasswordChange';
import AppSettings from './webConfig'
import axios from 'axios';

const App = () => {
    const {setCurrentColor, setCurrentMode, currentMode} = useStateContext();
    const [isOpenedAlready, setIsOpenedAlready] = useState(false)


    useEffect(() => {
        const getWebConfig = async () => {

            const { data } = await axios.get('/Tapu/AppSetting.json');
            sessionStorage.setItem('webConfig', JSON.stringify(data));
            sessionStorage.setItem('Url', data.Service);

            AppSettings.Service = data.Service;
            AppSettings.ApplicationName = data.ApplicationName;
            AppSettings.CityName = data.CityName;
            AppSettings.CityCode = data.CityCode;
            AppSettings.CountyName = data.CountyName;
            AppSettings.CountyCode = data.CountyCode;
            AppSettings.MunicipalityName = data.MunicipalityName;
            window.document.title = data.MunicipalityName

        }

        getWebConfig();
    }, []);

    useEffect(() => {
        const currentThemeColor = localStorage.getItem('colorMode');
        const currentThemeMode = localStorage.getItem('themeMode');
        if (currentThemeColor && currentThemeMode) {
            setCurrentColor(currentThemeColor);
            setCurrentMode(currentThemeMode);
        }
    }, [setCurrentColor, setCurrentMode]);

    useEffect(() => {
        window.addEventListener('resize', () => {
            const width = window.innerWidth;
            const zoom = width / 1920;
            document.body.style.zoom = zoom;
        });

        const width = window.innerWidth;
        const zoom = width / 1920;
        document.body.style.zoom = zoom;
    }, [])

    useEffect(() => {
        const channel = new BroadcastChannel('Belsoft2022#WebTapu');

        channel.postMessage({
            isOpenedAlready: true,
        })

        channel.addEventListener('message', (e) => {
            setIsOpenedAlready(e.data.isOpenedAlready)
            if (e.data.isOpenedAlready === true) {
                channel.close();
            }
        })

        return channel.close
    }, [])

    return (
        <div className={currentMode === 'Dark' ? 'dark' : ''}>
            {
                isOpenedAlready
                    ? <div style={{display: "flex", alignItems: "center", width: "100%", flexDirection: "column", marginTop: "5%"}}>
                        <h1>Sadece bir sekmede çalışabilirsiniz, lütfen bu sekmeyi kapatın.</h1>
                        <BlsButton onClick={() => window.location.reload()} type="approval">Sayfayı Yenile</BlsButton>
                    </div>
                    : <BrowserRouter>
                        <Routes>
                            <Route path={`${ParameterConstants.URL_EXTENSION}/Login`} element={<CustomLogin/>}/>
                            <Route path={`${ParameterConstants.URL_EXTENSION}/ChangePassword`} element={<PasswordChange/>}/>
                            <Route path={`${ParameterConstants.URL_EXTENSION}`} element={<TapuRayicBedel/>}/>
                        </Routes>
                    </BrowserRouter>
            }

            <ToastContainer/>
        </div>
    );
};

export default App;
